import jQuery from "jquery";
import "slick-carousel";

const $ = jQuery;

const interval = setInterval(() => {
    // Check if slick exists
    if ($(".fit-guide-silhouette-landing-slider.slider-small").slick) {
        clearInterval(interval);
        // eslint-disable-next-line func-names
        (() => {
            const carouselA = $(
                ".fit-guide-silhouette-landing-slider.slider-small",
            );
            carouselA.not(".slider-small.slick-initialized").slick({
                dots: true,
                arrows: false,
                accessibility: true,
                adaptiveHeight: false,
                infinite: false,
                // lazyLoad: 'ondemand',
                slidesToShow: 1.275,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1670,
                        settings: {
                            slidesToShow: 1.1,
                        },
                    },
                    {
                        breakpoint: 1036,
                        settings: {
                            slidesToShow: 1.2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                ],
            });
            const carouselB = $(
                ".fit-guide-silhouette-landing-slider.slider-expanded",
            );
            carouselB.not(".expanded.slick-initialized").slick({
                dots: true,
                arrows: false,
                accessibility: true,
                adaptiveHeight: false,
                infinite: false,
                // lazyLoad: 'ondemand',
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                ],
            });
        })();
    }
}, 100);

const silhouetteItems = document.querySelectorAll(
    ".fit-guide-silhouette__grid-contianer .grid__item",
);
silhouetteItems.forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const attribute = e.target
            .closest(".grid__item")
            .getAttribute("block-id");
        const scollToElement = document
            .querySelector(`#${attribute}`)
            .closest(".fit-guide-silhouette-landing__container");

        const yOffset = -120;
        const y =
            scollToElement.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    });
});
